<template>
	<div class="dropshipper-wrapper">
		<label class="custom-control custom-checkbox large white mt-4">
			<input
				type="checkbox"
				class="custom-control-input ooef-dropship-toggle"
				:input="checked"
				@change="onChecked"
			>
			<div class="custom-control-label">
				<b :style="getStyle(node)">Kirim sebagai Seller</b>
			</div>
		</label>
		<div
			class="dropship-box card p-3 mt-4"
			v-if="checked">
			<div class="form-group">
				<label>Nama</label>
				<input
					type="text"
					name="dropshipper-name"
					class="form-control dropshipper-name"
					required
					:value="name"
					@input="onNameInput"
				>
			</div>
			<div class="form-group">
				<label>No. Handphone / WhatsApp</label>
				<input
					type="phone"
					name="dropshipper-phone"
					class="form-control dropshipper-phone"
					required
					:value="phone"
					@input="onPhoneInput"
				>
			</div>
		</div>
	</div>
</template>

<script>
import {
	getNodeStyle,
} from '@/lib/helper';

export default {
	name: 'DropshipFields',
	props: {
		node: Object,
		checked: {
			type: Boolean,
			default: false,
		},
		name: {
			type: String,
			default: '',
		},
		phone: {
			type: String,
			default: '',
		},
	},
	methods: {
		onChecked(e) {
			const isChecked = e.target.checked;
			this.$emit('update:checked', isChecked);
		},
		onNameInput(e) {
			const name = e.target.value;
			this.$emit('update:name', name);
		},
		onPhoneInput(e) {
			const phone = e.target.value;
			this.$emit('update:phone', phone);
		},
		getStyle({ options }) {
			const styles = [
				'text-color',
			];
			const style = getNodeStyle(options, styles);
			return style;
		},
	},
};
</script>
